import type { HideUnsubmittedAfter } from "../../../../../../shared/schema";

export const DEFAULT_HIDE_UNSUBMITTED_AFTER: HideUnsubmittedAfter = { amount: 7, unit: "days" };
